
       var head = jQuery("#iFrameResizer0").contents().find("head");
    var css = '<style type="text/css">' +
        '#submitButton .btn{color: green !important}' +
        '</style>';
    jQuery(head).append(css);
console.log('aaaaaaaaaaaaaaaaaaaa');


//client love home slider
var shopSl = new Swiper(".client-love-wrap", {
    spaceBetween: 10,
    slidesPerView: 1,
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
          el: ".swiper-pagination",
      }
    
  });





//stiker scroll animation
$(document).ready(function(){
   var bodyHeight = $("body").height()-$(window).height();
   window.onscroll = function() {

      //Determine the amount to rotate by.
      var deg = window.scrollY*(360/bodyHeight);
      var deg2 = deg*4;
      $(".rotate-stiker").css({
        "transform": "rotate("+deg2+"deg)",
      });

   };


  
});

//footer
$( ".footer__blocks-wrapper .footer-block--menu" ).wrapAll( "<div class='footer-navigation'></div>" );

//button

$('.full-unstyled-link').addClass('button-animation');
$('.ss-section .button').addClass('button-animation');


  $('main').css('padding-top','127px');
  if($('.home').length){
    $('main').css('padding-top','0px');
      console.log('aasdad');
  }

// $('.header__icon.header__icon--menu').click(function(){
//   $('.header-wrapper').toggleClass('active-menu2');
// })


$(function(){
  $('.custom-tab .tab-title').on('click',function(){ 
   
    if($(this).parent('.custom-tab').find('.tab-content').hasClass('active')) {    
      $(this).parent('.custom-tab').find('.tab-content').removeClass('active');
    }
    else {
      $(this).parent('.custom-tab').find('.tab-content').addClass('active');
    }
     
  }); 
});

  

//prodcut page buttons
$('.prodcut-buttons-group').wrapAll('<div class="prodcuts--buttons--group"></div>');


$('.product__info-wrapper .custom-tab .tab-title').click(function(){
  $(this).parent('.custom-tab').find('.tab--pluss svg > line:nth-child(1)').toggleClass('line-active');
});
$('.product__accordion summary').click(function(){
  $(this).find('svg > line:nth-child(1)').toggleClass('line-active');
});


//prodcut
$('.eng-fake label').click(function(){
  $(this).find('input').toggleClass('active');
});

//
$('.ss-text__content__button-container a').removeClass('button-animation');

//let clone = $('.product-add-button').clone();
//clone.addClass('clone-tabs');

//$('.prodcuts--buttons--group').append(clone);

//
// $('.home .header--split-nav li').click(function(){
//   $('.home').addClass('bg-scroll');
// });


$('.home .header-split-left li.second').click(function(){
  
  if($('.second .mega-menu[open]').length > 0){
    console.log('0999999');
    $('.home').removeClass('bg-scroll2');
   
  }
  else{
    $('.home').addClass('bg-scroll2');
    
  }

    
  
});





$('.product__info-wrapper .custom-tab .tab-title').click(function(){
  $(this).parent('.custom-tab').find('.tab--pluss svg > line:nth-child(1)').toggleClass('line-active');
});
$('.product__accordion summary').click(function(){
  $(this).find('svg > line:nth-child(1)').toggleClass('line-active');
});



$('.product__info-wrapper .shopify-app-block ').after('<a class="customize-design-button" target="_blank" href="https://www.wrmetalarts.com/pages/our-customizing-form">CUSTOMIZE DESIGN</a>');


//add textarea function in product variants 
$(document).ready(function(){
  $('.infinite-option-teaxarea > div').click(function(){
      console.log('click click click');
      $('.infinite-option-teaxarea span').toggleClass('text-area-active');
    
  });

// setTimeout(function() {
//   $('#infiniteoptions-container > div').addClass('infinite-option'); 
// }, 1500)


  
});



$(document).ready(function(){
  // if($('.color-swatch-label[for="color-swatches-yellow"]')){

  //   // $(this).css('background-image','url(https://cdn.shopify.com/s/files/1/0064/5716/3840/files/swatch-yellow-gold.jpg?v=1663856418)');
  //   $('.color-swatch-label[for="color-swatches-yellow"]').css('background-color','#FFD374');
  // }  
  // if($('.color-swatch-label[for="color-swatches-rose"]')){
 
  //   //$(this).css('background-image','url(https://cdn.shopify.com/s/files/1/0064/5716/3840/files/swatch-rose-gold.jpg?v=1663856418)');
  //   $('.color-swatch-label[for="color-swatches-rose"]').css('background-color','#FBC6AC');
  // }
  // if($('.color-swatch-label[for="color-swatches-white"]')){
 
  //   //$(this).css('background-image','url(https://cdn.shopify.com/s/files/1/0064/5716/3840/files/swatch-rose-gold.jpg?v=1663856418)');
  //   $('.color-swatch-label[for="color-swatches-white"]').css('background-color','#DCDBD7');
  // }
// $('.color-swatch-label[for="color-swatches-yellow"]').css('background-color','#FFD374');
// $('.color-swatch-label[for="color-swatches-rose"]').css('background-color','#FBC6AC');
// $('.color-swatch-label[for="color-swatches-white"]').css('background-color','#DCDBD7'); 
});


$('.header__icon--search').click(function() {
  setTimeout(function() { 
    $( ".search__input" ).focus();
  }, 400);
 
});



